import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import { connect, useDispatch } from "react-redux";
import { fetchProfessions } from "../../actions/professions";
import jsPDF from "jspdf";
import {
  resetApplication,
  startApplication
} from "../../actions/application/startApplication";
import { setSurvey } from "../../actions/application/setSurvey";
import { useNavigate } from "react-router";
import { Link, Navigate, useParams } from "react-router-dom";

import Swal from "sweetalert2";
import { logOut } from "../../actions/auth/login";
import robotoLight from "../../helpers/fonts/robotoLight";
import robotoBold from "../../helpers/fonts/robotoBold";
import logo from "../../helpers/onedose_black.png";
import { getApplication } from "../../actions/application/getApplication";

function TriageEdit(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Id, From } = useParams();

  useEffect(() => {
    dispatch(getApplication(Id));
  }, [dispatch]);

  const [mounted, setMounted] = useState(false);

  const [displayCard, setDisplayCard] = useState("triageform");
  const [professionId, setProfessionId] = useState("");

  const [cures, setCure] = useState([
    {
      r1: "",
      r2: "",
      r3: "",
      r4: ""
    }
  ]);
  const [medicines, setMedicine] = useState([
    {
      r1: "",
      r2: ""
    }
  ]);
  const [addictions, setAddiction] = useState([
    {
      r1: "",
      r2: ""
    }
  ]);
  const [operations, setOperation] = useState([{}]);
  const [pdfFile, setPdfFile] = useState("");
  const [allergies, setAllergy] = useState(false);
  const [relativeDisease, setRelativeDisease] = useState(false);
  const [approve, setApprove] = useState(false);
  const [approve2, setApprove2] = useState(false);

  const [form, setForm] = useState({
    "Görüş Almak İstediğiniz Uzmanlık Alanı": "",
    "Görüş Almak İstediğiniz Hastalık": "",
    "Görüş Almak İstediğiniz Konu": {
      "Yakın zamanda konulan bir teşhis hakkında görüş almak istiyorum": "",
      "Planlanan bir ameliyat hakkında görüş almak istiyorum": "",
      "Yaşadığım, bir türlü sağlıklı bir çözüme ulaşmayan kronik bir tıbbi sorunumla ilgili görüş almak istiyorum":
        "",
      "Halihazırda uygulanmakta olan/Önerilen tedavi planım hakkında görüş almak istiyorum":
        "",
      "Hastalığımla ilişkili cevaplanmasını istediğim spesifik sorularım var":
        ""
    },
    "Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi": "",
    "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri": "",
    "Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar": "",
    "Geçirilmiş Operasyonlar": {},
    "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {},
    "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar": "",
    "Kullanımı devam eden ilaçlar": {},
    Alışkanlıklar: {},
    "Alerji durumunuz": "",
    "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?": ""
  });

  const handleExportToPDF = () => {
    const doc = new jsPDF({
      orientation: "p", // portrait modu
      unit: "pt",
      format: "a4"
    });
    doc.addFileToVFS("Roboto-Regular.ttf", robotoLight);
    doc.addFileToVFS("Roboto-Bold.ttf", robotoBold);
    doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");
    doc.setFont("Roboto", "normal");

    let offsetY = 50;
    const pageWidth = 595; // Portrait modda A4 kağıdının genişliği pt cinsinden
    const pageHeight = 842; // Portrait modda A4 kağıdının yüksekliği pt cinsinden
    const textWidth = pageWidth - 60; // Metnin genişliği, sağ ve sol kenardan 30'ar puanlık boşluk bırakacak şekilde ayarlanır.

    doc.addImage(logo, "PNG", 545, 6, 40, 30); // Resim formatı, pozisyon ve boyutları ayarlayın

    // Başlık
    doc.setFontSize(16);
    doc.setFont("Roboto", "bold");
    doc.text("İkinci Görüş Başvuru Formu", 10, 23);
    offsetY += 20; // Başlık için boşluk bırakıyoruz.
    doc.setLineWidth(1);
    doc.line(10, 40, 595 - 10, 40); // Çizginin pozisyonunu ve uzunluğunu ayarlayın

    doc.setFontSize(12); // Metin boyutunu ayarlayalım.

    // Form verilerini PDF'e ekle
    for (const property in form) {
      const value = form[property];
      if (typeof value === "object") {
        offsetY += 10;
        doc.setFont("Roboto", "bold");

        // Yeni sayfa kontrolü
        if (offsetY + 20 > pageHeight) {
          doc.addPage();
          offsetY = 30; // Yeni sayfada en üstte başlamak için.
        }

        doc.text(property, 10, offsetY);
        offsetY += 20; // Başlık için boşluk bırakıyoruz.

        for (const subProperty in value) {
          const subValue = value[subProperty];
          doc.setFont("Roboto", "normal");

          const textLines = doc.splitTextToSize(
            `${subProperty}: ${subValue}`,
            textWidth
          );

          for (let i = 0; i < textLines.length; i++) {
            // Yeni sayfa kontrolü
            if (offsetY + 15 > pageHeight) {
              doc.addPage();
              offsetY = 30; // Yeni sayfada en üstte başlamak için.
            }

            doc.text(textLines[i], 20, offsetY);
            offsetY += 15; // Alt satır için boşluk bırakıyoruz.
          }
        }

        offsetY += 10; // Yeni başlık için boşluk bırakıyoruz.
      } else {
        doc.setFont("Roboto", "normal");

        const textLines = doc.splitTextToSize(
          `${property}: ${value}`,
          textWidth
        );

        for (let i = 0; i < textLines.length; i++) {
          // Yeni sayfa kontrolü
          if (offsetY + 15 > pageHeight) {
            doc.addPage();
            offsetY = 30; // Yeni sayfada en üstte başlamak için.
          }

          doc.text(textLines[i], 20, offsetY);
          offsetY += 15; // Alt satır için boşluk bırakıyoruz.
        }
      }
    }

    const pdfAsBase64 = doc.output("datauristring");
    setPdfFile(pdfAsBase64);
  };
  function handleSubmit(event) {
    event.preventDefault();
    const jsonForm = JSON.stringify(form);
    handleExportToPDF();
    var surveyData = JSON.stringify({
      ApplicationId: Id,
      SurveyName: "data",
      TotalQuestions: 0,
      TotalAnswered: 0,
      Data: jsonForm,
      ExternalId: pdfFile
    });
    dispatch(setSurvey(surveyData));

    setMounted(true);
    navigate("/applications");
  }
  useEffect(() => {
    dispatch(resetApplication());
  }, [dispatch]);

  useEffect(() => {
    if (props.getApplication.done) {
      let surveyJson = props.getApplication.getApplication.survey.data;
      let survey = JSON.parse(surveyJson);

      let incomingOperations = survey["Geçirilmiş Operasyonlar"];
      let incomingTreatments =
        survey["Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"];
      let incomingMedicines = survey["Kullanımı devam eden ilaçlar"];
      let incomingAddictions = survey["Alışkanlıklar"];
      let incomingAllergies = survey["Alerji durumunuz"];
      let incomingRelativeDisease =
        survey["Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?"];
      let incomingDisease = survey["Görüş Almak İstediğiniz Hastalık"];
      let incomingDiseaseDate =
        survey["Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi"];
      let incomingDiagnoses =
        survey[
          "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri"
        ];
      let incomingOtherNotes =
        survey["Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar"];
      let incomingOtherDiseases =
        survey[
          "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar"
        ];
      let incomingSpecial = survey["Görüş Almak İstediğiniz Uzmanlık Alanı"];
      setForm((prevState) => ({
        ...prevState,
        "Alerji durumunuz": incomingAllergies,
        "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?":
          incomingRelativeDisease,
        "Görüş Almak İstediğiniz Hastalık": incomingDisease,
        "Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi": incomingDiseaseDate,
        "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri":
          incomingDiagnoses,
        "Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar":
          incomingOtherNotes,
        "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar":
          incomingOtherDiseases,
        "Görüş Almak İstediğiniz Uzmanlık Alanı": incomingSpecial
      }));

      // setForm()

      if (typeof incomingOperations === "object") {
        incomingOperations = Object.values(incomingOperations);
      }
      if (typeof incomingTreatments === "object") {
        let treatmentsArray = [];
        for (let i = 0; ; i++) {
          if (incomingTreatments[`Tedavi Adı ${i}`]) {
            treatmentsArray.push({
              r1: incomingTreatments[`Tedavi Adı ${i}`],
              r2: incomingTreatments[`Tedavi Durumu ${i}`],
              r3: incomingTreatments[`Tedavi Başlangıç Tarihi ${i}`],
              r4: incomingTreatments[`Tedavi Bitiş Tarihi ${i}`] || ""
            });
          } else {
            break;
          }
        }

        setCure(treatmentsArray);
      }
      if (typeof incomingMedicines === "object") {
        let medicinesArray = [];
        for (let i = 0; ; i++) {
          if (incomingMedicines[`İlaç adı ve dozu ${i}`]) {
            medicinesArray.push({
              r1: incomingMedicines[`İlaç adı ve dozu ${i}`],
              r2: incomingMedicines[`İlaç başlangıç zamanı ${i}`] || ""
            });
          } else {
            break;
          }
        }
        setMedicine(medicinesArray);
      }
      if (typeof incomingAddictions === "object") {
        let addictionsArray = [];

        // Gelen objeyi dönerek addictions formatına uygun bir array oluşturuyoruz.
        for (let i = 0; ; i++) {
          if (incomingAddictions[`Alışkanlık ${i}`]) {
            addictionsArray.push({
              r1: incomingAddictions[`Alışkanlık ${i}`],
              r2: incomingAddictions[`Kullanım Durumu ${i}`] || ""
            });
          } else {
            break;
          }
        }

        setAddiction(addictionsArray);
      }

      setOperation(incomingOperations.map((op) => ({ text: op })));

      setForm((prevState) => ({
        ...prevState,
        "Geçirilmiş Operasyonlar": incomingOperations.reduce(
          (acc, op, index) => {
            acc["Geçirilmiş Operasyon " + index] = op;
            return acc;
          },
          {}
        )
      }));
    }
  }, [props.getApplication.done]); // Bağımlılık olarak sadece props.getApplication.done'u kullanıyoruz.

  return (
    <div className="">
      <Header />
      <div className="md:justify-center">
        <div className="mb-10" id="triageformcard">
          <div className="pt-10 md:ml-64 ps-5">
            <ol
              className="flex items-center whitespace-nowrap min-w-0"
              aria-label="Breadcrumb"
            >
              <li className="text-sm">
                <a
                  onClick={() => {
                    setDisplayCard("forwho");
                  }}
                  className="flex items-center text-gray-500 hover:text-blue-600"
                  href="#"
                >
                  Yeni Başvuru
                  <svg
                    className="flex-shrink-0 mx-3 overflow-visible h-2.5 w-2.5 text-gray-400 dark:text-gray-600"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                </a>
              </li>
              <li
                className="text-sm font-semibold text-gray-800 truncate dark:text-gray-200"
                aria-current="page"
              >
                Başvuru Formunu Düzenle
              </li>
            </ol>
          </div>
          <hr className="divide-y mt-2" />

          <div className="md:ml-64 ps-5 mt-5">
            <label
              for="input-label"
              className="text-start block text-sm font-medium mb-2 dark:text-white"
            >
              Görüş Almak İstediğiniz Hastalık
            </label>
            <input
              onChange={(e) => {
                setForm((prevState) => ({
                  ...prevState,
                  "Görüş Almak İstediğiniz Hastalık": e.target.value
                }));
              }}
              type="text"
              defaultValue={form["Görüş Almak İstediğiniz Hastalık"]}
              id="input-label"
              className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              placeholder="Görüş almak istediğiniz hastalığınızı giriniz"
            />
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <label
              for="input-label"
              className="text-start block text-sm font-medium mb-2 dark:text-white"
            >
              Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi
            </label>
            <input
              onChange={(e) => {
                setForm((prevState) => ({
                  ...prevState,
                  "Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi":
                    e.target.value
                }));
              }}
              defaultValue={
                form["Görüş Almak İstediğiniz Hastalığın Teşhis Tarihi"]
              }
              type="text"
              id="input-label"
              className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              placeholder="Lütfen bir tarih giriniz. (Örn; 2 yıl önce, Ağustos 2022)"
            />
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <label
              for="input-label"
              className="text-start block text-sm font-medium mb-2 dark:text-white"
            >
              Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri
            </label>
            <textarea
              onChange={(e) => {
                setForm((prevState) => ({
                  ...prevState,
                  "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri":
                    e.target.value
                }));
              }}
              defaultValue={
                form[
                  "Daha Önce Başvurulan Hekim/Sağlık Merkezleri ve Başvuru Tarihleri"
                ]
              }
              rows="4"
              type="text"
              id="input-label"
              className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              placeholder="Lütfen görüş almak istediğiniz hastalığınız ile ilgili daha önce başvurduğunuz hekim/sağlık merkezleri ve başvuru tarihlerini belirtiniz."
            />
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <label
              for="input-label"
              className="text-start block text-sm font-medium mb-2 dark:text-white"
            >
              Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar
            </label>
            <textarea
              onChange={(e) => {
                setForm((prevState) => ({
                  ...prevState,
                  "Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar":
                    e.target.value
                }));
              }}
              defaultValue={
                form["Hastalık İle İlgili Aktarılmak İstenen Diğer Notlar"]
              }
              rows="4"
              type="text"
              id="input-label"
              className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              placeholder="Lütfen belirtiniz"
            />
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <label
              for="input-label"
              className="text-start block text-sm font-medium mb-2 dark:text-white"
            >
              Geçirilmiş Operasyonlar
            </label>

            {operations.map((element, index) => (
              <textarea
                key={index}
                onChange={(e) => {
                  setForm((prevState) => ({
                    ...prevState,
                    "Geçirilmiş Operasyonlar": {
                      ...prevState["Geçirilmiş Operasyonlar"],
                      ["Geçirilmiş Operasyon " + index]: e.target.value
                    }
                  }));
                }}
                defaultValue={element.text}
                rows="4"
                type="text"
                id="input-label"
                className=" mt-2 py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                placeholder="Lütfen görüş almak istediğiniz hastalığınız ile ilgili operasyon adı, tarihi ve operasyonun gerçekleştirildiği sağlık merkezi bilgilerini giriniz"
              />
            ))}
            <div className="flex justify-end">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  const newOperations = [...operations];
                  newOperations.pop();
                  setOperation(newOperations);
                }}
                href="#"
                for="input-label"
                className=" block text-sm font-medium mb-2 danger mt-2 me-2"
              >
                <i class="fa-light fa-minus me-1"></i>
                Daha az
              </a>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setOperation([...operations, { text: "" }]);
                }}
                href="#"
                for="input-label"
                className=" block text-sm font-medium mb-2 onedose-color mt-2"
              >
                <i className="fa-light fa-plus me-1"></i>
                Daha fazla
              </a>
            </div>
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <h1 className="text-start mb-2 text-xl font-semibold">
              Hastalık İle İlgili Günümüze Dek Alınan Tedaviler:
            </h1>
            {cures.map((element, index) => (
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label
                    htmlFor={`question_10_1_${index}`}
                    className="text-start block text-sm font-medium mb-2 dark:text-white"
                  >
                    Tedavi Adı
                  </label>
                  <input
                    onChange={(e) => {
                      setCure(
                        cures.map((c, i) =>
                          i === index ? { ...c, r1: e.target.value } : c
                        )
                      );
                      setForm((prevState) => ({
                        ...prevState,
                        "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                          ...prevState[
                            "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                          ],
                          ["Tedavi Adı " + index]: e.target.value
                        }
                      }));
                    }}
                    defaultValue={element.r1}
                    name={`question_10_1_${index}`}
                    type="text"
                    id={`q9_${index}`}
                    className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                    placeholder="Tedavi/İlaç adını giriniz"
                  />
                </div>
                <div>
                  <label
                    htmlFor={`question_10_2_${index}`}
                    class="text-start block text-sm font-medium mb-2 dark:text-white"
                  >
                    Tedavi Durumu
                  </label>
                  <select
                    onChange={(e) => {
                      setCure(
                        cures.map((c, i) =>
                          i === index ? { ...c, r2: e.target.value } : c
                        )
                      );
                      setForm((prevState) => ({
                        ...prevState,
                        "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                          ...prevState[
                            "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                          ],
                          ["Tedavi Durumu " + index]: e.target.value
                        }
                      }));
                    }}
                    defaultValue={element.r2}
                    name={`question_10_2_${index}`}
                    id={`q10_${index}`}
                    class="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  >
                    <option value="" disabled selected>
                      Lütfen seçiniz
                    </option>
                    <option value="Devam Ediyor">Devam ediyor</option>
                    <option value="Sonlandı">Sonlandı</option>
                  </select>
                </div>
                <div>
                  <label
                    htmlFor={`question_10_3_${index}`}
                    className="text-start block text-sm font-medium mb-2 dark:text-white"
                  >
                    Başlangıç Tarihi
                  </label>
                  <input
                    onChange={(e) => {
                      setCure(
                        cures.map((c, i) =>
                          i === index ? { ...c, r3: e.target.value } : c
                        )
                      );
                      setForm((prevState) => ({
                        ...prevState,
                        "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler": {
                          ...prevState[
                            "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                          ],
                          ["Tedavi Başlangıç Tarihi " + index]: e.target.value
                        }
                      }));
                    }}
                    defaultValue={element.r3}
                    id={`question_10_3_${index}`}
                    name={`q11_${index}`}
                    type="text"
                    className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                    placeholder="Örn 2018"
                  />
                </div>
                <div>
                  {element.r2 == "Sonlandı" ? (
                    <div>
                      <label
                        htmlFor={`question_10_4_${index}`}
                        className="text-start block text-sm font-medium mb-2 dark:text-white"
                      >
                        Bitiş Tarihi
                      </label>
                      <input
                        type="text"
                        onChange={(e) => {
                          setCure(
                            cures.map((c, i) =>
                              i === index ? { ...c, r4: e.target.value } : c
                            )
                          );
                          setForm((prevState) => ({
                            ...prevState,
                            "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler":
                              {
                                ...prevState[
                                  "Hastalık İle İlgili Günümüze Dek Alınan Tedaviler"
                                ],
                                ["Tedavi Bitiş Tarihi " + index]: e.target.value
                              }
                          }));
                        }}
                        defaultValue={element.r4}
                        id={`q12_${index}`}
                        name={`question_10_4_${index}`}
                        className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                        placeholder="Örn 2022"
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            ))}

            <div className="flex justify-end">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  const newCures = [...cures];
                  newCures.pop();
                  setCure(newCures);
                }}
                href="#"
                for="input-label"
                className=" block text-sm font-medium mb-2 danger mt-2 me-2"
              >
                <i class="fa-light fa-minus me-1"></i>
                Daha az
              </a>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setCure([...cures, { r1: "", r2: "", r3: "", r4: "" }]);
                }}
                href="#"
                for="input-label"
                className=" block text-sm font-medium mb-2 onedose-color mt-2"
              >
                <i className="fa-light fa-plus me-1"></i>
                Daha fazla
              </a>
            </div>
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <label
              for="input-label1"
              className="text-start block text-sm font-medium mb-2 dark:text-white"
            >
              Görüş Alınmak İstenen Hastalık Dışında Varsa Diğer Hastalıklar
              (Özgeçmiş)
            </label>
            <textarea
              onChange={(e) => {
                setForm((prevState) => ({
                  ...prevState,
                  "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar":
                    e.target.value
                }));
              }}
              defaultValue={
                form[
                  "Görüş alınmak istenen hastalık dışında varsa diğer hastalıklar"
                ]
              }
              rows="4"
              type="text"
              id="input-label1"
              className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              placeholder="Bilinen diğer hastalıklar"
            />
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <h1 className="text-start mb-2 text-xl font-semibold">
              Kullanımı Devam Eden İlaçlar :
            </h1>
            {medicines.map((element, index) => (
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label
                    htmlFor={`question_20_1_${index}`}
                    className="text-start block text-sm font-medium mb-2 dark:text-white"
                  >
                    İlaç Adı ve Dozu
                  </label>
                  <input
                    onChange={(e) => {
                      setMedicine(
                        medicines.map((c, i) =>
                          i === index ? { ...c, r1: e.target.value } : c
                        )
                      );
                      setForm((prevState) => ({
                        ...prevState,
                        "Kullanımı devam eden ilaçlar": {
                          ...prevState["Kullanımı devam eden ilaçlar"],
                          ["İlaç adı ve dozu " + index]: e.target.value
                        }
                      }));
                    }}
                    id={`question_20_1_${index}`}
                    defaultValue={element.r1}
                    type="text"
                    className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                    placeholder="İlaç adı ve dozunu giriniz"
                  />
                </div>
                <div>
                  <label
                    htmlFor={`question_10_4_${index}`}
                    class="text-start block text-sm font-medium mb-2 dark:text-white"
                  >
                    Başklangıç Zamanı
                  </label>
                  <input
                    onChange={(e) => {
                      setMedicine(
                        medicines.map((c, i) =>
                          i === index ? { ...c, r2: e.target.value } : c
                        )
                      );
                      setForm((prevState) => ({
                        ...prevState,
                        "Kullanımı devam eden ilaçlar": {
                          ...prevState["Kullanımı devam eden ilaçlar"],
                          ["İlaç başlangıç zamanı " + index]: e.target.value
                        }
                      }));
                    }}
                    defaultValue={element.r2}
                    id={`q12_${index}`}
                    name={`question_10_4_${index}`}
                    className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  />
                </div>
              </div>
            ))}

            <div className="flex justify-end">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  const newMedicines = [...medicines];
                  newMedicines.pop();
                  setMedicine(newMedicines);
                }}
                href="#"
                for="input-label"
                className=" block text-sm font-medium mb-2 danger mt-2 me-2"
              >
                <i class="fa-light fa-minus me-1"></i>
                Daha az
              </a>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setMedicine([...medicines, { r1: "", r2: "" }]);
                }}
                for="input-label"
                href="#"
                className=" block text-sm font-medium mb-2 onedose-color mt-2"
              >
                <i className="fa-light fa-plus me-1"></i>
                Daha fazla
              </a>
            </div>
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <h1 className="text-start mb-2 text-xl font-semibold">
              Alışkanlıklar
            </h1>
            {addictions.map((element, index) => (
              <div className="grid grid-cols-2 gap-2">
                <div>
                  <label
                    htmlFor={`question_20_1_${index}`}
                    className="text-start block text-sm font-medium mb-2 dark:text-white"
                  >
                    Alışkanlığınızın Türü
                  </label>
                  <input
                    onChange={(e) => {
                      setAddiction(
                        addictions.map((c, i) =>
                          i === index ? { ...c, r1: e.target.value } : c
                        )
                      );
                      setForm((prevState) => ({
                        ...prevState,
                        Alışkanlıklar: {
                          ...prevState["Alışkanlıklar"],
                          ["Alışkanlık " + index]: e.target.value
                        }
                      }));
                    }}
                    defaultValue={element.r1}
                    id={`question_20_1_${index}`}
                    type="text"
                    className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                    placeholder="Örn: Sigara"
                  />
                </div>
                <div>
                  <label
                    htmlFor={`question_10_4_${index}`}
                    class="text-start block text-sm font-medium mb-2 dark:text-white"
                  >
                    Kullanım Süresi
                  </label>
                  <input
                    onChange={(e) => {
                      setAddiction(
                        addictions.map((c, i) =>
                          i === index ? { ...c, r2: e.target.value } : c
                        )
                      );
                      setForm((prevState) => ({
                        ...prevState,
                        Alışkanlıklar: {
                          ...prevState["Alışkanlıklar"],
                          ["Kullanım Durumu " + index]: e.target.value
                        }
                      }));
                    }}
                    defaultValue={element.r2}
                    id={`question_10_4_${index}`}
                    placeholder="Örn haftada 1 paket"
                    className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  />
                </div>
              </div>
            ))}

            <div className="flex justify-end">
              <a
                onClick={(e) => {
                  e.preventDefault();
                  const newAddictions = [...addictions];
                  newAddictions.pop();
                  setAddiction(newAddictions);
                }}
                href="#"
                for="input-label"
                className=" block text-sm font-medium mb-2 danger mt-2 me-2"
              >
                <i class="fa-light fa-minus me-1"></i>
                Daha az
              </a>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  setAddiction([...addictions, { r1: "", r2: "" }]);
                }}
                for="input-label"
                href="#"
                className=" block text-sm font-medium mb-2 onedose-color mt-2"
              >
                <i className="fa-light fa-plus me-1"></i>
                Daha fazla
              </a>
            </div>
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <div className="text-start">
              <label
                for="hs-select-label11"
                class="block text-sm font-medium mb-2 dark:text-white"
              >
                Alerji Durumunuz
              </label>
              <select
                onChange={(e) => {
                  setAllergy(e.target.value);
                  if (allergies !== "true") {
                    setForm((prevState) => ({
                      ...prevState,
                      "Alerji durumunuz": e.target.value
                    }));
                  }
                }}
                value={form["Alerji durumunuz"]}
                id={allergies == true ? null : "question_14"}
                className="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              >
                <option>Lütfen Seçiniz</option>
                <option value="true">Alerjim var</option>
                <option value="Alerjim yok">Alerjim yok</option>
              </select>
            </div>
            {allergies === "true" ? (
              <div>
                <label
                  for="input-132"
                  className="mt-2 text-start block text-sm font-medium mb-2 dark:text-white"
                >
                  Alerjilerinizi yazınız
                </label>
                <textarea
                  onChange={(e) => {
                    if (allergies === "true") {
                      setForm((prevState) => ({
                        ...prevState,
                        "Alerji durumunuz": e.target.value
                      }));
                    }
                  }}
                  defaultValue={form["Alerji durumunuz"]}
                  rows="4"
                  type="text"
                  id={allergies === true ? "question_14" : null}
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Lütfen alerjilerinizi ve bunlara ait detayları yazınız"
                />
              </div>
            ) : null}
            <div></div>
          </div>
          <div className="md:ml-64 ps-5 mt-5">
            <div className="text-start">
              <label
                for="hs-select-label11"
                class="block text-sm font-medium mb-2 dark:text-white"
              >
                Görüş Almak İstediğiniz Hastalığı Ailenizde Yaşayan Var mı?
              </label>
              <select
                onChange={(e) => {
                  setRelativeDisease(e.target.value);
                  if (relativeDisease !== "true") {
                    setForm((prevState) => ({
                      ...prevState,
                      "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?":
                        e.target.value
                    }));
                  }
                }}
                value={
                  form[
                    "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?"
                  ]
                }
                id={relativeDisease === true ? null : "question_15"}
                class="py-3 px-4 pr-9 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
              >
                <option selected>Lütfen Seçiniz</option>
                <option value="true">Evet</option>
                <option value="Hayır">Hayır</option>
              </select>
            </div>
            {relativeDisease === "true" ? (
              <div>
                <label
                  for="input-132"
                  className="mt-2 text-start block text-sm font-medium mb-2 dark:text-white"
                >
                  Lütfen Detay Giriniz (Ailenizde Bu Hastalığı Yaşayan Kişi İle
                  Alakalı?)
                </label>
                <textarea
                  onChange={(e) => {
                    if (relativeDisease === "true") {
                      setForm((prevState) => ({
                        ...prevState,
                        "Görüş almak istediğiniz hastalığı ailenizde yaşayan var mı?":
                          e.target.value
                      }));
                    }
                  }}
                  rows="4"
                  type="text"
                  id={relativeDisease === true ? "question_15" : null}
                  className="py-3 px-4 block w-full border-gray-200 rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-slate-900 dark:border-gray-700 dark:text-gray-400"
                  placeholder="Yakınlık derecesi (anne, baba, vs), hastalığın süresi ve güncel durum bilgisi"
                />
              </div>
            ) : null}
            <div></div>
          </div>

          <div className="md:ml-64 ps-5 mt-5">
            <button
              onClick={handleSubmit}
              style={{ backgroundColor: `#09C35C` }}
              type="button"
              class="mb-10  w-full py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800 mt-5"
            >
              Güncelle
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(TriageEdit);
